import { useEffect, useState } from "react";
import { ImageList, ImageListItem, ImageListItemBar, CircularProgress } from "@mui/material";
import { Box } from "@mui/material/node_modules/@mui/system";
import { Brand, getImages, Image } from "api";

interface ImagesPageProps {
  activeBrand?: Brand;
  actionButton?: (item: Image) => JSX.Element;
  setApi?: ({ data, setData }: { data: Partial<Image>[], setData: Function }) => void
}

export function ImagesGallery({ activeBrand, actionButton, setApi }: ImagesPageProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<Partial<Image>[]>([]);

  useEffect(() => {
    if (setApi) {
      setApi({ data, setData });
    }
  }, [setApi, data, setData]);

  useEffect(() => {
    getImages({ brandId: activeBrand?.id }).then(results => {
      if (activeBrand) {
        setData(results.filter(({brandId}) => brandId === activeBrand.id));
      } else {
        setData(results);
      }
      setIsLoading(false);
    });
  }, [activeBrand, setData, setIsLoading]);

  if (isLoading) {
    return <CircularProgress />
  }
  return (
    <ImageList cols={2} rowHeight={164}>
      {data.map((item: any) => (
        <ImageListItem key={item.id}>
          <Box
            sx={{
              backgroundImage: `url("${item.url}")`,
              backgroundSize: 'contain',
              backgroundPosition: "center",
              backgroundRepeat: 'no-repeat',
              height: '100px',
              width: '100%',
            }}
          />
          <ImageListItemBar
            title={item.name}
            position="below"
            actionIcon={actionButton && actionButton(item)}
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}
